import axios from 'axios';
import moment from 'moment';
import Head from 'next/head';
import { NSPageBlogArticle, NSContext } from 'aqlrc';
import getAPIUrl from '../../lib/getAPIUrl';
import { withI18next } from '../../lib/withI18n';
import Layout from '../../components/Layout';
import { Router } from '../../routes';
import Error from '../_error';


class PageBlogArticle extends NSPageBlogArticle {
    static getInitialProps = async function (ctx) {
        const { lang } = ctx.nsGlobals;
        const res = await axios.post(`${getAPIUrl(ctx)}v2/site/new`, {
            lang,
            PostBody : {
                filter : {
                    [`translation.${lang}.slug`] : ctx.query._slug,
                },
            }
        });

        let pathUrl = '';
        if (ctx.req) {
            pathUrl = `${ctx.req.protocol}://${ctx.req.headers.host}`;
        } else {
            pathUrl = `${window.location.origin}`;
        }

        return {
            article       : res.data,
            pathUrl
        };
    };

    render() {
        const {
            article, lang, oCmsHeader, oCmsFooter, sitename, t
        } = this.props;
        if (!article) {
            return (
                <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                    <Error statusCode={404} message="Not found" oCmsHeader={oCmsHeader} oCmsFooter={oCmsFooter} />);
                </NSContext.Provider>
            );
        }
        let pathUrl = this.props.pathUrl;
        if (pathUrl === '') {
            pathUrl = window.location.href;
        }
        const url = pathUrl ? `${pathUrl.split('/')[0]}//${pathUrl.split('/')[2]}` : '';
        return (
            <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                <Layout header={oCmsHeader.content} footer={oCmsFooter.content}>
                    <Head>
                        <title>{sitename} | Blog</title>
                        <meta property="og:type" content="website" />
                    </Head>
                    <div className="intro intro--homepage" style={{ backgroundImage: 'url("/medias/functionality.png")', backgroundColor: '#00020e' }}>
                        <div className="intro__title">
                            <h1>Blog</h1>
                        </div>
                    </div>
                    <section className="section-contact section-contact--main">
                        <div className="shell">
                            <div itemType="http://schema.org/Article">
                                <div>
                                    <button type="button" className="btn btn--form btn--blue" onClick={() => Router.back()}>{t('common:retour')}</button>
                                </div>
                                <h2 className="section__title decoration-line-mixed">{article.title}</h2>

                                <div itemProp="image" itemScope="" itemType="http://schema.org/ImageObject">
                                    <meta itemProp="url" content={`${url}/${article.img}`} />
                                </div>

                                <div className="section__body">
                                    <div className="section__inner">
                                        <div className="article-date" itemProp="datePublished" content={moment(article.createdAt).format('DD/MM/YYYY - HH[h]mm')} style={{ marginBottom: '20px' }}>
                                            {moment(article.createdAt).format('DD/MM/YYYY - HH[h]mm')}
                                        </div>
                                        <div itemProp="articleBody" className="ns-article-content" dangerouslySetInnerHTML={{ __html: article.content.text }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Layout>
            </NSContext.Provider>
        );
    }
}

export default withI18next(['article'])(PageBlogArticle);
